"use client";

import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
function GuidesGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="rounded-2xl border border-border bg-card p-6">
            <div className="aspect-[4/3] rounded-xl bg-muted animate-pulse" />
            <div className="mt-5 h-5 w-24 rounded-lg bg-muted animate-pulse" />
            <div className="mt-4 h-6 w-3/4 rounded bg-muted animate-pulse" />
            <div className="mt-3 h-4 w-full rounded bg-muted animate-pulse" />
            <div className="mt-2 h-4 w-5/6 rounded bg-muted animate-pulse" />
          </div>)}
      </div>;
  }
  if (error) {
    return <p className="text-center font-default" style={{
      color: "var(--muted-foreground)"
    }}>
        Unable to load articles right now.
      </p>;
  }
  if (posts.length === 0) {
    return <p className="text-center font-default" style={{
      color: "var(--muted-foreground)"
    }}>
        No articles published yet — check back soon.
      </p>;
  }
  const formatDate = (dateStr?: string) => {
    if (!dateStr) return "";
    try {
      return new Date(dateStr).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
      });
    } catch {
      return "";
    }
  };
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.slice(0, 6).map((post, i) => {
      const category = post.categories && post.categories.length > 0 ? post.categories[0] : null;
      const authorName = post.author?.name || "";
      const dateLabel = formatDate(post.date);
      return <Link key={post.id} to={post.link || "#"} data-index={i} className="group block rounded-2xl border-[1.5px] p-6 shadow-md transition-all duration-300 hover:shadow-lg focus:outline-none focus-visible:ring-[3px] focus-visible:ring-offset-4" style={{
        backgroundColor: "var(--card)",
        borderColor: "var(--border)",
        color: "var(--foreground)"
      }}>
            <div className="relative overflow-hidden rounded-xl" style={{
          backgroundColor: "var(--muted)"
        }}>
              {}
              <svg aria-hidden="true" viewBox="0 0 200 80" className="absolute -top-4 -left-6 w-40 opacity-60 pointer-events-none" fill="var(--card)">
                <path d="M40 60 C 20 60, 10 40, 30 32 C 30 18, 55 12, 65 24 C 78 8, 108 12, 112 30 C 132 24, 152 36, 148 52 C 172 52, 176 72, 154 76 L 44 76 C 32 76, 30 66, 40 60 Z" />
              </svg>
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                {post.featuredImage ? <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" /> : <div className="flex h-full w-full items-center justify-center font-serif text-2xl" style={{
              color: "var(--muted-foreground)"
            }}>
                    SCREENADO
                  </div>}
              </div>
            </div>

            <div className="mt-5 flex flex-col gap-3">
              {category && <Badge className="rounded-lg border-0 px-3 py-1 font-default text-xs font-semibold" style={{
            backgroundColor: "var(--secondary)",
            color: "var(--primary)"
          }}>
                  {category.name}
                </Badge>}

              <h3 className="font-serif text-xl font-medium leading-snug line-clamp-2" style={{
            color: "var(--foreground)",
            letterSpacing: "-0.01em"
          }}>
                {post.title}
              </h3>

              {post.excerpt && <p className="font-default text-sm leading-relaxed line-clamp-3" style={{
            color: "var(--muted-foreground)"
          }} dangerouslySetInnerHTML={{
            __html: post.excerpt.replace(/<[^>]*>/g, "")
          }} />}

              <div className="mt-2 flex items-center justify-between pt-4 border-t" style={{
            borderColor: "var(--border)"
          }}>
                <div className="flex flex-col font-default text-xs" style={{
              color: "var(--muted-foreground)"
            }}>
                  {authorName && <span className="font-semibold">{authorName}</span>}
                  {dateLabel && <span>{dateLabel}</span>}
                </div>
                <span className="flex h-9 w-9 items-center justify-center rounded-lg transition-transform duration-300 group-hover:translate-x-1.5" style={{
              color: "#004282"
            }} aria-hidden="true">
                  <ArrowRight className="size-5" />
                </span>
              </div>
            </div>
          </Link>;
    })}
    </div>;
}
export default function Spotlight() {
  return;
}